import { v } from '@/theme/tokens';

export function Spinner({ size = 20, label }: { size?: number; label?: string }) {
  if (label) {
    return (
      <div
        role="status"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          color: v('ink-muted'),
          fontSize: 13.5,
          padding: '12px 0',
        }}
      >
        <SpinnerRing size={size} />
        {label}
      </div>
    );
  }
  return (
    <div role="status" aria-label="Загрузка" style={{ display: 'inline-flex' }}>
      <SpinnerRing size={size} />
    </div>
  );
}

function SpinnerRing({ size }: { size: number }) {
  return (
    <div
      aria-hidden
      className="rt-spinner"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `2px solid ${v('line')}`,
        borderTopColor: v('accent'),
        animation: 'spin 0.8s linear infinite',
      }}
    />
  );
}

export function LoadingScreen({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div
      role="status"
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        color: v('ink-muted'),
        fontSize: 13.5,
      }}
    >
      <SpinnerRing size={26} />
      {label}
    </div>
  );
}

/** Skeleton matching the KPI grid, so the layout does not jump on load. */
export function KpiGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div
      role="status"
      aria-label="Загрузка показателей"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(240px, 100%), 1fr))',
        gap: 14,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="rt-card" style={{ padding: 18, height: 108 }} aria-hidden>
          <div
            className="rt-skeleton"
            style={{ width: '45%', height: 10, borderRadius: 6, marginBottom: 14 }}
          />
          <div className="rt-skeleton" style={{ width: '70%', height: 22, borderRadius: 6 }} />
        </div>
      ))}
    </div>
  );
}
